import React from "react";
import { AxiosConfiguration } from "./AxiosConfig";
import * as Constant from "./constants";
import { Link } from "react-router-dom";
import {
  get_Date,
  generateParticipantGroupID,
  generateSurveyAnalysisReportID,
  generateSurveyID,
  generateDeviceID,
  getSurveyStatusName,
} from "./commonFunctions";

/* 
  Purpose:    Used to maintain the active class of admin module navigation
  Component:  AdminNavigation.jsx
  Created By: Vinit Kumar 
*/
export let admin_active_component = (props) => {
  let dashboardNavClass;
  let manufacturerNavClass;
  let devicesNavClass;
  let participantGroupsNavClass;
  let surveyNavClass;
  let surveyAnalysisReportListNavClass;
  let manageadministrateruserNavClass;
  let manageimportparticipantsNavClass;
  let importdataNavClass;
  let managedraftNavClass;
  let managereportNavClass;

  const fullPath = window.location.href;
  const currentComponent = fullPath.substring(fullPath.lastIndexOf("/") + 1);

  let url = fullPath.split("/");
  const currentComponent2 = url[url.length - 2];

  const currentComponent4 = url[url.length - 4];

  if (currentComponent === "AdminDashboard") {
    dashboardNavClass = "nav-link custom-active";
    manufacturerNavClass = "nav-link";
    devicesNavClass = "nav-link";
    participantGroupsNavClass = "nav-link";
    surveyNavClass = "nav-link";
    surveyAnalysisReportListNavClass = "nav-link";
    importdataNavClass = "nav-link";
    managedraftNavClass = "nav-link";
    managereportNavClass = "nav-link";
  }

  if (
    currentComponent === "AdminListManufacturer" ||
    currentComponent === "AdminAddManufacturer" ||
    currentComponent === "AdminListSites" ||
    currentComponent2 === "AdminListSites" ||
    currentComponent === "AdminAddSite" ||
    currentComponent2 === "AdminAddSite" ||
    currentComponent === "AdminListUsers" ||
    currentComponent2 === "AdminListUsers" ||
    currentComponent === "AdminAddUser" ||
    currentComponent2 === "AdminAddUser" ||
    currentComponent === "AdminEditUser" ||
    currentComponent2 === "AdminEditUser"
  ) {
    manufacturerNavClass = "nav-link custom-active";
    dashboardNavClass = "nav-link";
    devicesNavClass = "nav-link";
    participantGroupsNavClass = "nav-link";
    surveyNavClass = "nav-link";
    surveyAnalysisReportListNavClass = "nav-link";
    importdataNavClass = "nav-link";
    managedraftNavClass = "nav-link";
    managereportNavClass = "nav-link";
  }

  if (
    currentComponent === "AdminListDevices" ||
    currentComponent === "AdminAddDevice"
  ) {
    devicesNavClass = "nav-link custom-active";
    manufacturerNavClass = "nav-link";
    dashboardNavClass = "nav-link";
    participantGroupsNavClass = "nav-link";
    surveyAnalysisReportListNavClass = "nav-link";
    surveyNavClass = "nav-link";
    importdataNavClass = "nav-link";
    managedraftNavClass = "nav-link";
    managereportNavClass = "nav-link";
  }

  if (
    currentComponent === "AdminListParticipantGroups" ||
    currentComponent2 === "AdminListParticipantGroups" ||
    currentComponent === "AdminAddParticipantGroup" ||
    currentComponent2 === "AdminAddParticipantGroup" ||
    currentComponent === "AdminListParticipants" ||
    currentComponent2 === "AdminListParticipants" ||
    currentComponent === "AdminAddParticipant" ||
    currentComponent2 === "AdminAddParticipant" ||
    currentComponent === "AdminAddParticipantsAssing" ||
    currentComponent2 === "AdminAddParticipantsAssing"
  ) {
    devicesNavClass = "nav-link";
    manufacturerNavClass = "nav-link";
    dashboardNavClass = "nav-link";
    surveyNavClass = "nav-link";
    surveyAnalysisReportListNavClass = "nav-link";
    participantGroupsNavClass = "nav-link custom-active";
    importdataNavClass = "nav-link";
    managedraftNavClass = "nav-link";
    managereportNavClass = "nav-link";
  }

  if (
    currentComponent === "survey" ||
    currentComponent2 === "survey" ||
    currentComponent === "add-survey" ||
    currentComponent2 === "add-survey" ||
    currentComponent === "AdminAddParticipantQualification" ||
    currentComponent2 === "AdminAddParticipantQualification" ||
    currentComponent === "AdminCreateSurveyQuestion" ||
    currentComponent2 === "AdminCreateSurveyQuestion" ||
    currentComponent === "AdminSurveyDetails" ||
    currentComponent2 === "AdminSurveyDetails" ||
    currentComponent === "AdminListResponses" ||
    currentComponent2 === "AdminListResponses" ||
    currentComponent === "AdminCreateAnalysis" ||
    currentComponent2 === "AdminCreateAnalysis" ||
    currentComponent === "AdminParticipantQualificationView" ||
    currentComponent2 === "AdminParticipantQualificationView" ||
    currentComponent === "AdminEditSurveyQuestion" ||
    currentComponent2 === "AdminEditSurveyQuestion" ||
    currentComponent === "AdminAnalysisPreview" ||
    currentComponent2 === "AdminAnalysisPreview" ||
    currentComponent4 === "AdminAnalysisPreview" ||
    currentComponent === "AdminAnalysisDownload" ||
    currentComponent2 === "AdminAnalysisDownload" ||
    currentComponent4 === "AdminAnalysisDownload"
  ) {
    devicesNavClass = "nav-link";
    manufacturerNavClass = "nav-link";
    dashboardNavClass = "nav-link";
    participantGroupsNavClass = "nav-link";
    surveyAnalysisReportListNavClass = "nav-link";
    surveyNavClass = "nav-link custom-active";
    importdataNavClass = "nav-link";
    managedraftNavClass = "nav-link";
    managereportNavClass = "nav-link";
  }

  if (
    currentComponent === "AdminListSurveyAnalysisReport" ||
    currentComponent2 === "AdminListSurveyAnalysisReport" ||
    currentComponent === "AdminSurveyAnalysisReport" ||
    currentComponent2 === "AdminSurveyAnalysisReport" ||
    currentComponent === "AdminSurveyAnalysisReportPreview" ||
    currentComponent2 === "AdminSurveyAnalysisReportPreview"
  ) {
    devicesNavClass = "nav-link";
    manufacturerNavClass = "nav-link";
    dashboardNavClass = "nav-link";
    participantGroupsNavClass = "nav-link";
    surveyNavClass = "nav-link";
    surveyAnalysisReportListNavClass = "nav-link custom-active";
    importdataNavClass = "nav-link";
    managedraftNavClass = "nav-link";
    managereportNavClass = "nav-link";
  }
  if (
    currentComponent === "ManageAdministratorUser" ||
    currentComponent === "AddAdministratorUser"
  ) {
    manageadministrateruserNavClass = "nav-link custom-active";
    manufacturerNavClass = "nav-link";
    devicesNavClass = "nav-link";
    participantGroupsNavClass = "nav-link";
    surveyNavClass = "nav-link";
    surveyAnalysisReportListNavClass = "nav-link";
    importdataNavClass = "nav-link";
    managedraftNavClass = "nav-link";
    managereportNavClass = "nav-link";
  }

  if (
    currentComponent === "manage-participants" ||
    currentComponent === "import-participants"
  ) {
    manageimportparticipantsNavClass = "nav-link custom-active";
    manufacturerNavClass = "nav-link";
    devicesNavClass = "nav-link";
    participantGroupsNavClass = "nav-link";
    surveyNavClass = "nav-link";
    surveyAnalysisReportListNavClass = "nav-link";
    importdataNavClass = "nav-link";
    managedraftNavClass = "nav-link";
    managereportNavClass = "nav-link";
  }

  if (currentComponent === "imports") {
    manageimportparticipantsNavClass = "nav-link";
    manufacturerNavClass = "nav-link";
    devicesNavClass = "nav-link";
    participantGroupsNavClass = "nav-link";
    surveyNavClass = "nav-link";
    surveyAnalysisReportListNavClass = "nav-link";
    managedraftNavClass = "nav-link";
    managereportNavClass = "nav-link";
    importdataNavClass = "nav-link custom-active";
  }
  if (currentComponent === "survey-draft-approval") {
    manageimportparticipantsNavClass = "nav-link";
    manufacturerNavClass = "nav-link";
    devicesNavClass = "nav-link";
    participantGroupsNavClass = "nav-link";
    surveyNavClass = "nav-link";
    surveyAnalysisReportListNavClass = "nav-link";
    importdataNavClass = "nav-link";
    managedraftNavClass = "nav-link custom-active";
    managereportNavClass = "nav-link";
  }
  if (currentComponent === "survey-analysis-report-approval") {
    manageimportparticipantsNavClass = "nav-link";
    manufacturerNavClass = "nav-link";
    devicesNavClass = "nav-link";
    participantGroupsNavClass = "nav-link";
    surveyNavClass = "nav-link";
    surveyAnalysisReportListNavClass = "nav-link";
    importdataNavClass = "nav-link";
    managereportNavClass = "nav-link custom-active";
    managedraftNavClass = "nav-link";
  }
  return {
    dashboard_nav: dashboardNavClass,
    manufacturer_nav: manufacturerNavClass,
    devices_nav: devicesNavClass,
    participant_groups_nav: participantGroupsNavClass,
    survey_nav: surveyNavClass,
    surveyanalysisreport_nav: surveyAnalysisReportListNavClass,
    manageadministrateruser_nav: manageadministrateruserNavClass,
    manageimportparticipants_nav: manageimportparticipantsNavClass,
    importdata_nav: importdataNavClass,
    managedraft_nav: managedraftNavClass,
    managereport_nav: managereportNavClass,
  };
};

/*
  Purpose: Used to get all site list
  Created By: Vinit Kumar 
*/
export const getSiteList = (manufacturerID) => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */
  const bodyFormData =
    new FormData(); /* create formData object to paas the parameters */
  bodyFormData.append("manufacturer_id", manufacturerID); /* input parameters */

  return axiosInstance
    .post("v1/sites_list/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        let optionItems = response.data.data.map((item, i) => (
          <tr key={++i}>
            <td>{++i}</td>
            <td>{item.site_name}</td>
            <td>{item.country__country_name}</td>
            <td>{item.state__state_name}</td>
            <td>{get_Date(item.created_date)}</td>
            <td>
              {item.can_be_deleted === "yes" ? (
                <button
                  className="btn btn-sm btn-danger"
                  data-toggle="modal"
                  data-target="#modal-default"
                  onClick={() => {
                    /* getting id of site to be deleted (defined in AdminSites.jsx component) */
                    document.getElementById("deleteListsite").value =
                      item.site_id;
                  }}
                >
                  <i className="fa fa-trash"></i>
                </button>
              ) : (
                <button className="btn btn-sm btn-danger" disabled>
                  <i className="fa fa-trash"></i>
                </button>
              )}
            </td>
          </tr>
        ));
        return optionItems;
      } else {
        const getMessage = (
          <tr>
            <td colSpan={6} className="text-center">
              {" "}
              {response.data.message}
            </td>
          </tr>
        );
        return getMessage; /* return message in case of record not found */
      }
    })
    .catch((error) => {
      return error;
    });
};

/*
  Purpose:    common function to delete the table records
  Created By: Vinit Kumar 
*/
export const deleteData = (id, table) => {
  const axiosInstance = AxiosConfiguration();
  const bodyFormData = new FormData();
  let url = "";

  /* check the table name and define the formData paramerts as per API input request */
  if (table === "SITES") {
    url = "v1/delete_manufacturer_site/";
    bodyFormData.append("site_id", id);
  }

  if (table === "USERS") {
    url = "app/v1/delete_user/";
    bodyFormData.append("user_id", id);
  }

  if (table === "DEVICE") {
    url = "v1/delete_device/";
    bodyFormData.append("device_id", id);
  }

  if (table === "PARTICIPANTGROUP") {
    url = "v1/delete_participant_group/";
    bodyFormData.append("participant_group_id", id);
  }
  if (table === "PARTICIPANT") {
    url = "v1/delete_participant/";
    bodyFormData.append("participant_id", id);
  }
  return axiosInstance
    .post(url, bodyFormData)
    .then((response) => {
      if (response.data.status) {
        return {
          status: response.data.status,
          message: response.data.message,
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: common function to delete record on multiple parameter condition
  Created By: Vinit Kumar 
*/

export const deleteDataMultipleCondition = (id1, id2, table) => {
  const axiosInstance = AxiosConfiguration();
  const bodyFormData = new FormData();
  let url = "";
  /* check the table name and define the formData paramerts as per API input request */
  if (table === "PARTICIPANT") {
    url = "v1/delete_group_participant/";
    bodyFormData.append("participant_id", id1);
    bodyFormData.append("participant_group_id", id2);
  }
  return axiosInstance
    .post(url, bodyFormData)
    .then((response) => {
      return {
        status: response.data.status,
        message: response.data.message,
      };
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose: common function to submit the table records
  Created By: Vinit Kumar 
*/
export const submitFormData = (Action, bodyFormData) => {
  const axiosInstance = AxiosConfiguration();
  let url = "";
  /* check action and define the formData paramerts as per API input request */
  switch (Action) {
    case "addSite":
      url = "v1/create_manufacturer_site/";
      break;
    case "addUser":
      url = "app/v1/auth/";
      break;
    case "addAdministratorUser":
      url = "app/v1/administrator_auth/";
      break;
    case "editUser":
      url = "app/v1/edit_user/";
      break;
    case "addDevice":
      url = "v1/create_device/";
      break;
    case "addParticipantGroup":
      url = "v1/create_participant_group/";
      break;
    case "AssingParticipantsTogroup":
      url = "v1/assing_participant_to_group/";
      break;
    case "addParticipant":
      url = "v1/create_participants/";
      break;
    case "addSurvey":
      url = "v1/create_survey/";
      break;
    case "add_survey_participant_qualification":
      url = "v1/create_survey_participant_qualification/";
      break;
    case "addSurveyQuestion":
      url = "v1/add_survey_form_data/";
      break;
    case "saveAnalysisGraph":
      url = "v1/build_survey_analysis_graph/";
      break;
    case "importParticipants":
      url = "v1/import_participants_csv/";
      break;
    case "updateparticipantdata":
      url = "v1/update_participant/";
      break;
    case "importCategory":
      url = "v1/import_category_csv/";
      break;
    case "importSpacialization":
      url = "v1/import_spacialization_csv/";
      break;
    case "importRegion":
      url = "v1/import_region_csv/";
      break;
    case "importCountry":
      url = "v1/import_country_csv/";
      break;
    case "importState":
      url = "v1/import_state_csv/";
      break;
    case "sentsurveyrequest":
      url = "v1/sent_survey_request/";
      break;
    default:
      break;
  }
  return axiosInstance
    .post(url, bodyFormData)
    .then((response) => {
      return {
        status: response.data.status,
        message: response.data.message,
        extra_data: response.data.extra_data,
      };
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to get user list (filter by site id)
  Created By: Vinit Kumar 
*/
export const getUserList = (bodyFormData) => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */

  return axiosInstance
    .post("app/v1/users_list/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        let optionItems = response.data.data.map((item, i) => (
          <tr key={++i}>
            <td>{++i}</td>
            <td>{item.first_name + " " + item.last_name}</td>
            <td>{item.email}</td>
            <td>{item.contact}</td>
            <td>{item.user_type === 3 ? "Primary User" : "Secondry User"}</td>
            <td>{item.site__site_name}</td>
            <td>{item.status === 1 ? "Active" : "Inactive"}</td>
            <td>{get_Date(item.created_date)}</td>
            <td>
              <Link
                to={"/AdminEditUser/" + item.user_id}
                className="btn btn-sm custom-btn-primary"
              >
                <i className="fa fa-edit"></i>
              </Link>{" "}
              {item.can_be_deleted === "yes" ? (
                <button
                  className="btn btn-sm btn-danger"
                  data-toggle="modal"
                  data-target="#modal-default"
                  onClick={() => {
                    /* getting id of site to be deleted (defined in AdminSites.jsx component) */
                    document.getElementById("deleteUser").value = item.user_id;
                  }}
                >
                  <i className="fa fa-trash"></i>
                </button>
              ) : (
                <button className="btn btn-sm btn-danger" disabled>
                  <i className="fa fa-trash"></i>
                </button>
              )}
            </td>
          </tr>
        ));
        return {
          status: "success",
          optionItems: optionItems,
        };
      } else {
        const getMessage = (
          <tr>
            <td colSpan={9} className="text-center">
              {" "}
              {response.data.message}
            </td>
          </tr>
        );
        return {
          status: "failure",
          optionItems: getMessage,
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to get site list (based on manufacturer id)
  Created By: Vinit Kumar 
*/
export const getSiteListByManufacturerID = (bodyFormData) => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */

  return axiosInstance
    .post("v1/get_sites_manufacturerId/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        const tmpValue = [];
        response.data.data.map((item) =>
          tmpValue.push({
            label: item.site_name,
            value: item.site_id,
          })
        );
        return {
          status: "success",
          optionItems: tmpValue,
        };
      } else {
        return {
          status: "failure",
          optionItems: "",
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/* 
  Purpose:    Used to get site dropdown by manufacturer ID
  Created By: Vinit Kumar 
*/

export const getSitesDropdownByManufacturerID = (mID) => {
  const axiosInstance = AxiosConfiguration();
  let bodyFormData = new FormData();
  bodyFormData.append("manufacturer_ids", mID);
  return axiosInstance
    .post("v1/get_sites_manufacturerId/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        let optionItems = response.data.data.map((item) => (
          <option key={item.site_id} value={item.site_id}>
            {item.site_name}
          </option>
        ));
        return {
          status: "success",
          optionItems: optionItems,
        };
      } else {
        return {
          status: "failure",
          message: Constant.API_ERROR,
        };
      }
    })
    .catch((error) => {
      return {
        status: "error",
        message: Constant.API_ERROR,
      };
    });
};

/* 
  Purpose:    Used to get user details by user_id
  Created By: Vinit Kumar 
*/
export const getUserDetailsByUserID = (uID) => {
  const axiosInstance = AxiosConfiguration();
  let bodyFormData = new FormData();
  bodyFormData.append("user_id", uID);
  return axiosInstance
    .post("app/v1/user_details/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        let res = response.data.data[0];
        return {
          status: "success",
          data: res,
        };
      } else {
        return {
          status: "failure",
          message: Constant.API_ERROR,
        };
      }
    })
    .catch((error) => {
      return {
        status: "error",
        message: Constant.API_ERROR,
      };
    });
};

/*
  Purpose: Used to get all device list
  Created By: Vinit Kumar 
*/
export const getDeviceList = (bodyFormData) => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */
  return axiosInstance
    .post("v1/device_list/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        let optionItems = response.data.data.map((item, i) => (
          <tr key={++i}>
            <td>{++i}</td>
            <td>
              <img className="listImage" src={item.device_image} />
            </td>
            <td>{generateDeviceID(item.site_id, item.device_id)}</td>
            <td>{item.device_name}</td>
            <td>{item.manufacturer__company_name}</td>
            <td>{item.site__site_name}</td>
            <td>{get_Date(item.created_date)}</td>
            <td>
              {item.can_be_deleted === "yes" ? (
                <button
                  className="btn btn-sm btn-danger"
                  data-toggle="modal"
                  data-target="#modal-default"
                  onClick={() => {
                    /* getting id of site to be deleted (defined in AdminSites.jsx component) */
                    document.getElementById("deleteDevice").value =
                      item.device_id;
                  }}
                >
                  <i className="fa fa-trash"></i>
                </button>
              ) : (
                <button className="btn btn-sm btn-danger" disabled>
                  <i className="fa fa-trash"></i>
                </button>
              )}
            </td>
          </tr>
        ));
        return {
          status: "success",
          optionItems: optionItems,
        };
      } else {
        const getMessage = (
          <tr>
            <td colSpan={8} className="text-center">
              {" "}
              {response.data.message}
            </td>
          </tr>
        );
        return {
          status: "failure",
          optionItems: getMessage,
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to get manufacturer list (multiple)
  Created By: Vinit Kumar 
*/
export const getMultipleManufacturerList = () => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */

  return axiosInstance
    .post("v1/get_manufacturer/")
    .then((response) => {
      if (response.data.data) {
        const tmpValue = [];
        response.data.data.map((item) =>
          tmpValue.push({
            label: item.company_name,
            value: item.manufacturer_id,
          })
        );
        return {
          status: "success",
          optionItems: tmpValue,
        };
      } else {
        return {
          status: "failure",
          optionItems: "",
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to get manufacturer list (single select dropdown)
  Created By: Vinit Kumar 
*/
export const getSingleSelectManufacturerDropdown = () => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */

  return axiosInstance
    .post("v1/get_manufacturer/")
    .then((response) => {
      if (response.data.data) {
        let optionItems = response.data.data.map((item) => (
          <option key={item.manufacturer_id} value={item.manufacturer_id}>
            {item.company_name}
          </option>
        ));

        return {
          status: "success",
          optionItems: optionItems,
        };
      } else {
        return {
          status: "failure",
          optionItems: "",
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to get sites list (single select dropdown filter by manufacturer id)
  Created By: Vinit Kumar 
*/
export const getSingleSelectSitesDropdown = (bodyFormData) => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */

  return axiosInstance
    .post("v1/sites_list/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        let optionItems = response.data.data.map((item) => (
          <option key={item.site_id} value={item.site_id}>
            {item.site_name}
          </option>
        ));

        return {
          status: "success",
          optionItems: optionItems,
        };
      } else {
        return {
          status: "failure",
          optionItems: "",
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to get all device list
  Created By: Vinit Kumar 
*/
export const getParticipantGroupList = (bodyFormData) => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */
  return axiosInstance
    .post("v1/participant_group_list/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        let optionItems = response.data.data.map((item, i) => (
          <tr key={++i}>
            <td>{++i}</td>
            <td>
              {generateParticipantGroupID(
                item.site_id,
                item.participant_group_id
              )}
            </td>
            <td>{item.manufacturer__company_name}</td>
            <td>{item.site__site_name}</td>
            <td>{item.no_of_participant}</td>
            <td>{get_Date(item.created_date)}</td>
            <td>
              <Link
                to={"/AdminListParticipants/" + item.participant_group_id}
                className="btn btn-sm custom-btn-primary"
              >
                Manage Participants
              </Link>{" "}
              {item.can_be_deleted === "yes" ? (
                <button
                  className="btn btn-sm btn-danger"
                  data-toggle="modal"
                  data-target="#modal-default"
                  onClick={() => {
                    /* getting id of site to be deleted (defined in AdminSites.jsx component) */
                    document.getElementById("deleteParticipantGroup").value =
                      item.participant_group_id;
                  }}
                >
                  <i className="fa fa-trash"></i>
                </button>
              ) : (
                <button className="btn btn-sm btn-danger" disabled>
                  <i className="fa fa-trash"></i>
                </button>
              )}
            </td>
          </tr>
        ));
        return {
          status: "success",
          optionItems: optionItems,
        };
      } else {
        const getMessage = (
          <tr>
            <td colSpan={7} className="text-center">
              {response.data.message}
            </td>
          </tr>
        );
        return {
          status: "failure",
          optionItems: getMessage,
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to get all device list
  Created By: Vinit Kumar 
*/
export const getParticipansList = (bodyFormData) => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */
  return axiosInstance
    .post("v1/participants_list/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        let optionItems = response.data.data.map((item, i) => (
          <tr key={++i}>
            <td>{++i}</td>
            <td>{item.first_name + " " + item.last_name}</td>
            <td>{item.profession_name}</td>
            <td>{item.country_name}</td>
            <td>{item.email}</td>
            <td>{item.contact}</td>
            <td>{get_Date(item.created_date)}</td>
            <td>
              {item.can_be_deleted === "yes" ? (
                <button
                  className="btn btn-sm btn-danger"
                  data-toggle="modal"
                  data-target="#modal-default"
                  onClick={() => {
                    /* getting id of site to be deleted (defined in AdminSites.jsx component) */
                    document.getElementById("deleteParticipant").value =
                      item.assign_id;
                  }}
                >
                  <i className="fa fa-trash"></i>
                </button>
              ) : (
                <button className="btn btn-sm btn-danger" disabled>
                  <i className="fa fa-trash"></i>
                </button>
              )}
            </td>
          </tr>
        ));
        return {
          status: "success",
          optionItems: optionItems,
        };
      } else {
        const getMessage = (
          <tr>
            <td colSpan={8} className="text-center">
              {" "}
              {response.data.message}
            </td>
          </tr>
        );
        return {
          status: "failure",
          optionItems: getMessage,
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/* 
  Purpose:    Used to get the manufacturer list only
  Created By: Dinesh kumar 
*/
export const getManufacturesDropdowns = () => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("v1/get_manufacturer/")
    .then((response) => {
      let results = response.data.data;
      if (results) {
        const optionItems = results.map((item) => (
          <option key={item.manufacturer_id} value={item.manufacturer_id}>
            {item.company_name}
          </option>
        ));
        return { optionItems: optionItems };
      } else {
        return { optionItems: "" };
      }
    })
    .catch((error) => {
      console.log(error);
      return false;
    });
};

/* 
  Purpose:    Used to get the devices list by site id
  Created By: Dinesh kumar 
*/
export const getDevicesDropdownBySiteID = (siteID) => {
  const axiosInstance = AxiosConfiguration();
  let bodyFormData = new FormData();
  bodyFormData.append("site_id", siteID);
  return axiosInstance
    .post("v1/get_device_list/", bodyFormData)
    .then((response) => {
      let results = response.data.data;
      if (results) {
        const optionItems = results.map((item) => (
          <option key={item.device_id} value={item.device_id}>
            {item.device_name}
          </option>
        ));
        return { optionItems: optionItems };
      } else {
        return { optionItems: "" };
      }
    })
    .catch((error) => {
      console.log(error);
      return false;
    });
};

/* 
  Purpose:    Used to get the Participants Group list by site id
  Created By: Dinesh kumar 
*/

export const getParticipantsGroupDropdownBySiteID = (siteID) => {
  const axiosInstance = AxiosConfiguration();
  let bodyFormData = new FormData();
  bodyFormData.append("site_id", siteID);
  return axiosInstance
    .post("v1/get_participant_group_bysite/", bodyFormData)
    .then((response) => {
      let results = response.data.data;
      if (results) {
        const optionItems = results.map((item) => (
          <option
            key={item.participant_group_id}
            value={item.participant_group_id}
          >
            {generateParticipantGroupID(
              item.site_id,
              item.participant_group_id
            )}
          </option>
        ));
        return { optionItems: optionItems };
      } else {
        return { optionItems: "" };
      }
    })
    .catch((error) => {
      console.log(error);
      return false;
    });
};

/* 
  Purpose:    Used to get survey details by survey id
  Created By: Vinit kumar 
*/
export const getSurveyDetails = (surveyID) => {
  const axiosInstance = AxiosConfiguration();
  let bodyFormData = new FormData();
  bodyFormData.append("survey_id", surveyID);
  return axiosInstance
    .post("v1/survey_details/", bodyFormData)
    .then((response) => {
      console.log(response)
      let results = response.data.data;
      
      if (results) {
        return {
          status: "success",
          results: results[0],
        };
      } else {
        return {
          status: "failure",
          message: "Result not found",
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to check display of action buttons on survey details component 
  Created By: Vinit Kumar 
*/
export const buttonDisplay = (buttonName, surveyStatus) => {
  if (
    buttonName === "Responses" &&
    (surveyStatus === "launched" ||
      surveyStatus === "final_save" ||
      surveyStatus === "completed" ||
      surveyStatus === "survey_released" ||
      surveyStatus === "survey_approved" ||
      surveyStatus === "survey_closed")
  ) {
    return true;
  } else if (
    buttonName === "Analysis" &&
    (surveyStatus === "final_save" ||
      surveyStatus === "completed" ||
      surveyStatus === "survey_released")
  ) {
    return true;
  } else if (
    buttonName === "Save Final Draft" &&
    (surveyStatus === "draft_created" || surveyStatus === "draft_rejected")
  ) {
    return true;
  } else if (
    buttonName === "Launch Survey" &&
    surveyStatus === "draft_approved"
  ) {
    return true;
  } else if (
    buttonName === "Edit Completion Date" &&
    surveyStatus === "launched"
  ) {
    return true;
  } else if (
    buttonName === "Release Survey to Primary User" &&
    surveyStatus === "final_save"
  ) {
    return true;
  } else if (
    buttonName === "Close survey" &&
    surveyStatus === "survey_approved"
  ) {
    return true;
  } else {
    return false;
  }
};

/*
  Purpose: Used to check display of process bar 
  Created By: Vinit Kumar 
*/
export const activeProcessBar = (processStage, surveyStatus) => {
  if (
    processStage === "Draft Released" &&
    (surveyStatus === "launched" ||
      surveyStatus === "draft_released" ||
      surveyStatus === "draft_approved" ||
      surveyStatus === "completed" ||
      surveyStatus === "final_save" ||
      surveyStatus === "survey_released" ||
      surveyStatus === "survey_approved" ||
      surveyStatus === "survey_closed")
  ) {
    return true;
  } else if (
    processStage === "Draft Approved" &&
    (surveyStatus === "draft_approved" ||
      surveyStatus === "launched" ||
      surveyStatus === "final_save" ||
      surveyStatus === "completed" ||
      surveyStatus === "survey_released" ||
      surveyStatus === "survey_approved" ||
      surveyStatus === "survey_closed")
  ) {
    return true;
  } else if (
    processStage === "Launched" &&
    (surveyStatus === "launched" ||
      surveyStatus === "final_save" ||
      surveyStatus === "completed" ||
      surveyStatus === "survey_released" ||
      surveyStatus === "survey_approved" ||
      surveyStatus === "survey_closed")
  ) {
    return true;
  } else if (
    processStage === "Completed" &&
    (surveyStatus === "final_save" ||
      surveyStatus === "completed" ||
      surveyStatus === "survey_released" ||
      surveyStatus === "survey_approved" ||
      surveyStatus === "survey_closed")
  ) {
    return true;
  } else if (
    processStage === "Survey Released" &&
    (surveyStatus === "survey_released" ||
      surveyStatus === "survey_approved" ||
      surveyStatus === "survey_closed")
  ) {
    return true;
  } else if (
    processStage === "Survey Approved" &&
    (surveyStatus === "survey_approved" || surveyStatus === "survey_closed")
  ) {
    return true;
  } else if (
    processStage === "Survey Closed" &&
    surveyStatus === "survey_closed"
  ) {
    return true;
  } else {
    return false;
  }
};

/* 
  Purpose:    Used to get survey preview by survey id
  Created By: Vinit kumar 
*/
export const getSurveyPreview = (surveyID) => {
  const axiosInstance = AxiosConfiguration();
  let bodyFormData = new FormData();
  bodyFormData.append("survey_id", surveyID);
  return axiosInstance
    .post("v1/admin_survey_form_preview/", bodyFormData)
    .then((response) => {
      let results = response.data.data.data;

      if (results) {
        const filter1 = results[0].form_json.replace(/"true"/g, "true"); // replace true
        const filter2 = filter1.replace(/"false"/g, "false"); // replace false
        const finalJson = filter2.replace(/"null"/g, "null"); // replace false

        return {
          status: "success",
          getSurveyName: results[0].survey_name,
          getConsent: results[0].consent_statement,
          getsurveyStatus: results[0].status,
          getParticipantQualificationStatus:
            results[0].participant_qualification,
          getFormJson: finalJson,
          getSiteId: results[0].site_id,
          getCompanyLogo: results[0].manufacturer__company_logo,
          isNotifyUser: response.data.data.isNotifyUser,
          users: response.data.data.users,
        };
      } else {
        return {
          status: "failure",
          message: "Result not found",
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/* 
  Purpose:    Used to get participant qualification view
  Created By: Vinit kumar 
*/
export const getParticipantQualificationView = (surveyID) => {
  const axiosInstance = AxiosConfiguration();
  let bodyFormData = new FormData();
  bodyFormData.append("survey_id", surveyID);
  return axiosInstance
    .post("v1/survey_participant_qualification/", bodyFormData)
    .then((response) => {
      let results = response.data.data;
      if (results) {
        return {
          status: "success",
          getsurveyID: results[0].survey_id,
          getSurveyName: results[0].survey_name,
          getCompanyLogo: results[0].manufacturer__company_logo,
          getDeviceImage: results[0].device__device_image,
          getCompanyName: results[0].manufacturer__company_name,
          getParticipantQualificationJson:
            results[0].participant_qualification_json,
        };
      } else {
        return {
          status: "failure",
          message: "Result not found",
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/* 
  Purpose:    Used to get survey question by survey id
  Created By: Dinesh kumar 
*/
export const getSurveyFormQuestion = (surveyID) => {
  const axiosInstance = AxiosConfiguration();
  let bodyFormData = new FormData();
  bodyFormData.append("survey_id", surveyID);
  return axiosInstance
    .post("v1/edit_survey/", bodyFormData)
    .then((response) => {
      let results = response.data.data;
      if (results) {
        const filter1 = results[0].form_json.replace(/"true"/g, "true"); // replace true
        const filter2 = filter1.replace(/"false"/g, "false"); // replace false
        const finalJson = filter2.replace(/"null"/g, "null"); // replace false

        return {
          status: "success",
          getSurveyName: results[0].survey_name,
          getSurveyID: results[0].survey_id,
          getSurveyStatus: results[0].status,
          getParticipantQualificationStatus:
            results[0].participant_qualification,
          getFormJson: finalJson,
        };
      } else {
        return {
          status: "failure",
          message: "Result not found",
        };
      }
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose:    common function to update  survey status
  Created By: Vinit Kumar 
*/
export const updateSurveStatus = (sID, surveyStatus) => {
  const axiosInstance = AxiosConfiguration();
  const bodyFormData = new FormData();
  let url = "v1/survey_update_status/"; 

  bodyFormData.append("survey_id", sID);
  bodyFormData.append("survey_status", surveyStatus);

  return axiosInstance
    .post(url, bodyFormData)
    .then((response) => {
      return {
        status: response.data.status,
        message: response.data.message,
      };
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to get Regions list (multiple) for creating analysis
  Created By: Vinit Kumar 
*/
export const getAnalysisRegionList = (surveyId) => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */
  const bodyFormData = new FormData();
  bodyFormData.append("survey_id", surveyId);
  return axiosInstance
    .post("v1/get_survey_participants_group_region/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        const tmpValue = [];
        response.data.data.map((item) =>
          tmpValue.push({
            label: item.region_name,
            value: item.region_name,
          })
        );
        return {
          status: "success",
          optionItems: tmpValue,
        };
      } else {
        return {
          status: "failure",
          optionItems: "",
        };
      }
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to get Countries list (multiple) for creating analysis
  Created By: Vinit Kumar 
*/
export const getAnalysisCountriesList = (bodyFormData) => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */
  return axiosInstance
    .post("v1/get_survey_participants_group_country/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        const tmpValue = [];
        let tempObj = response.data.data;
        tempObj.map((item) =>
          tmpValue.push({
            label: item,
            value: item,
          })
        );
        return {
          status: "success",
          optionItems: tmpValue,
        };
      } else {
        return {
          status: "failure",
          optionItems: "",
        };
      }
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to get Profession list (multiple) for creating analysis
  Created By: Vinit Kumar 
*/
export const getAnalysisProfessionList = (bodyFormData) => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */
  return axiosInstance
    .post("v1/get_survey_participants_group_profession/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        const tmpValue = [];
        let tempObj = response.data.data;
        tempObj.map((item) =>
          tmpValue.push({
            label: item,
            value: item,
          })
        );
        return {
          status: "success",
          optionItems: tmpValue,
        };
      } else {
        return {
          status: "failure",
          optionItems: "",
        };
      }
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose:    edit completion date api
  Created By: Vinit Kumar 
*/
export const editCompletionDateFunc = (surveyID, date) => {
  const axiosInstance = AxiosConfiguration();
  const bodyFormData = new FormData();
  bodyFormData.append("survey_id", surveyID);
  bodyFormData.append("completion_date", date);

  return axiosInstance
    .post("v1/update_survey_completion_date/", bodyFormData)
    .then((response) => {
      return {
        status: response.data.status,
        message: response.data.message,
      };
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose:    use to creating pagination on analysis page
  Created By: Vinit Kumar 
*/
export const analysisLandingData = (surveyID, per_page) => {
  const axiosInstance = AxiosConfiguration();
  const bodyFormData = new FormData();
  bodyFormData.append("survey_id", surveyID);
  bodyFormData.append("per_page", per_page);

  return axiosInstance
    .post("v1/create_survey_analysis/", bodyFormData)
    .then((response) => {
      if (response.data) {
        return {
          status: "success",
          data: response.data.data,
        };
      } else {
        return {
          status: response.data.status,
          message: response.data.message,
        };
      }
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose:    use to get chart data
  Created By: Vinit Kumar 
*/
export const getAnalysisChartData = (bodyFormData) => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("v1/build_survey_analysis_graph/", bodyFormData)
    .then((response) => {
      if (response.data) {
        return {
          status: "success",
          data: response.data.data,
        };
      } else {
        return {
          status: response.data.status,
          message: response.data.message,
        };
      }
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose:    use to save survey analysis report
  Created By: Vinit Kumar 
*/
export const saveSurveyAnalysisReport = (bodyFormData) => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("v1/survey_analysis_save/", bodyFormData)
    .then((response) => {
      if (response.data) {
        return {
          status: "success",
          message: response.data.message,
        };
      } else {
        return {
          status: response.data.status,
          message: response.data.message,
        };
      }
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose:    use to get survey analysis preview
  Created By: Vinit Kumar 
*/
export const getSurveyAnalysisPreview = (bodyFormData) => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("v1/survey_analysis_preview/", bodyFormData)
    .then((response) => {
      if (response.data) {
        return {
          status: "success",
          data: response.data.data,
        };
      } else {
        return {
          status: response.data.status,
          message: response.data.message,
        };
      }
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose:    use to get survey analysis download
  Created By: Vinit Kumar 
*/
export const getSurveyAnalysisDownload = (bodyFormData) => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("v1/analysis_preview_download/", bodyFormData)
    .then((response) => {
      if (response.data) {
        return {
          status: "success",
          data: response.data.data,
        };
      } else {
        return {
          status: response.data.status,
          message: response.data.message,
        };
      }
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose:    delete preview chart function
  Created By: Vinit Kumar 
*/
export const deleteAnalysisGraph = (surveyID, analysisID) => {
  const axiosInstance = AxiosConfiguration();
  const bodyFormData = new FormData();
  let url = "v1/delete_analysis_graph/";

  bodyFormData.append("survey_id", surveyID);
  bodyFormData.append("analysis_id", analysisID);
  return axiosInstance
    .post(url, bodyFormData)
    .then((response) => {
      return {
        status: response.data.status,
        message: response.data.message,
      };
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose:    get participant responses
  Created By: Vinit Kumar 
*/

export const viewSurveyParticipantResponses = (surveyID) => {
  const axiosInstance = AxiosConfiguration();
  const bodyFormData = new FormData();
  let url = "v1/view_survey_responses/";
  bodyFormData.append("survey_id", surveyID);
  return axiosInstance
    .post(url, bodyFormData)
    .then((response) => {
      if (response.data) {
        let tmpList = response.data.data.participants.map((item, i) => (
          <tr key={++i}>
            <td>{++i}</td>
            <td>
              {item.attempted_status === "1" ? (
                <Link
                  to={
                    "/AdminParticipantSurveyResponse/" +
                    surveyID +
                    "/" +
                    item.participant_id
                  }
                >
                  {item.participant__first_name}
                </Link>
              ) : (
                item.participant__first_name
              )}
            </td>
            <td>
              {item.disqualified == true
                ? "Disqualified"
                : item.attempted_status == 1
                ? "Submitted"
                : "Not Submitted"}
            </td>
          </tr>
        ));

        return {
          status: "success",
          data: response.data.data,
          participantList: tmpList,
          message: response.data.message,
        };
      } else {
        return {
          status: response.data.status,
          message: response.data.message,
        };
      }
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/* 
  Purpose:    Used to get survey response from participant
  Created By: Vinit kumar 
*/
export const getParticipantSurveyResponse = (surveyID, participantID) => {
  const axiosInstance = AxiosConfiguration();
  let bodyFormData = new FormData();
  bodyFormData.append("survey_id", surveyID);
  bodyFormData.append("participant_id", participantID);
  return axiosInstance
    .post("v1/participant_survey_responce/", bodyFormData)
    .then((response) => {
      let results = response.data.data;
      if (results) {
        const filter1 = results[0].form_json.replace(/"true"/g, "true"); // replace true
        const filter2 = filter1.replace(/"false"/g, "false"); // replace false
        const finalJson = filter2.replace(/"null"/g, "null"); // replace false

        const tmpData = JSON.stringify(results[0].form_data);

        const filterData1 = tmpData.replace(/"true"/g, "true"); // replace true
        const filterData2 = filterData1.replace(/"false"/g, "false"); // replace false
        const finalDataJson = filterData2.replace(/"null"/g, "null"); // replace false

        return {
          status: "success",
          getSurveyName: results[0].survey_name,
          getConsent: results[0].consent_statement,
          getsurveyStatus: results[0].status,
          getCompanyLogo: results[0].manufacturer__company_logo,
          getFormJson: finalJson,
          getDataJson: finalDataJson,
        };
      } else {
        return {
          status: "failure",
          message: "Result not found",
        };
      }
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to get all survey analysis report
  Created By: Vinit Kumar 
*/
export const getSurveyAnalysisReport = () => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */
  return axiosInstance
    .post("v1/survey_analysis_reports/")
    .then((response) => {
      if (response.data.data) {
        let sr = 0;
        let optionItems = response.data.data.map((item) => (
          <tr>
            <td>{++sr}</td>
            <td>{generateSurveyAnalysisReportID(item.survey_id, item.id)}</td>
            <td>{generateSurveyID(item.site_id, item.survey_id)}</td>
            <td>{item.survey__survey_name}</td>
            <td>{generateParticipantGroupID(item.site_id, item.survey_id)}</td>
            <td>{get_Date(item.created_date)}</td>
            <td>{getSurveyStatusName(item.survey__status)}</td>
            <td>
              <Link
                to={"/AdminSurveyAnalysisReport/" + item.survey_id}
                className="btn btn-sm custom-btn-primary"
              >
                View
              </Link>
            </td>
          </tr>
        ));
        return {
          status: "success",
          optionItems: optionItems,
        };
      } else {
        const getMessage = (
          <tr>
            <td colSpan={9}> {response.data.message}</td>
          </tr>
        );
        return {
          status: "failure",
          optionItems: getMessage,
        };
      }
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose:    use to get survey analysis report view
  Created By: Vinit Kumar 
*/
export const getSurveyAnalysisReportView = (bodyFormData) => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("v1/survey_analysis_reports_view/", bodyFormData)
    .then((response) => {
      if (response?.data) {
        return {
          status: "success",
          data: response?.data?.data,
        };
      } else {
        return {
          status: response?.data?.status,
          message: response?.data?.message,
        };
      }
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose:    use to get survey analysis report preview
  Created By: Vinit Kumar 
*/
export const getSurveyAnalysisReportPreView = (bodyFormData) => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("v1/survey_analysis_reports_preview/", bodyFormData)
    .then((response) => {
      if (response.data) {
        return {
          status: "success",
          data: response.data.data,
        };
      } else {
        return {
          status: response.data.status,
          message: response.data.message,
        };
      }
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose:    delete survey analysis report chart function
  Created By: Vinit Kumar 
*/
export const deleteSurveyAnalysisReportGraph = (surveyID, analysisID) => {
  const axiosInstance = AxiosConfiguration();
  const bodyFormData = new FormData();
  let url = "v1/delete_analysis_report_graph/";

  bodyFormData.append("survey_id", surveyID);
  bodyFormData.append("report_id", analysisID);

  return axiosInstance
    .post(url, bodyFormData)
    .then((response) => {
      return {
        status: response.data.status,
        message: response.data.message,
      };
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose:    use to include and exclude text response in survey analysis report
  Created By: Vinit Kumar 
*/
export const includeExcludeTextResponse = (surveyID, questionID, action) => {
  const axiosInstance = AxiosConfiguration();
  const bodyFormData = new FormData();
  let url = "v1/include_or_exclude_text_responces/";

  bodyFormData.append("survey_id", surveyID);
  bodyFormData.append("question_id", questionID);
  bodyFormData.append("action", action);

  return axiosInstance
    .post(url, bodyFormData)
    .then((response) => {
      return {
        status: response.data.status,
        message: response.data.message,
      };
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose:    use to get final survey analysis report download
  Created By: Vinit Kumar 
*/
export const getFinalSurveyAnalysisReportDownload = (bodyFormData) => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("v1/survey_analysis_reports_preview_download/", bodyFormData)
    .then((response) => {
      if (response.data) {
        return {
          status: "success",
          data: response.data.data,
        };
      } else {
        return {
          status: response.data.status,
          message: response.data.message,
        };
      }
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to get Administrator user list only(Sub admin and Quality supervisor)
  Created By: Dinesh Kumar 
*/
export const getAdministratorUserList = (bodyFormData) => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */

  return axiosInstance
    .post("app/v1/administrator_users_list/", bodyFormData) 
    .then((response) => {
      if (response.data.data) {
        let optionItems = response.data.data.map((item, i) => (
          <tr key={++i}>
            <td>{++i}</td>
            <td>{item.first_name}</td>
            <td>{item.last_name}</td>
            <td>{item.email}</td>
            <td>{item.user_department}</td>
            <td>
              {item.user_type === 4 ? "Sub Admin" : "Quality Supervisor"}
            </td>
            <td>{item.status === 1 ? "Active" : "Inactive"}</td>
            <td>{get_Date(item.created_date)}</td>
            <td>
              {/* <Link
                to={"/AdminEditUser/" + item.user_id}
                className="btn btn-sm custom-btn-primary"
              >
                <i className="fa fa-edit"></i>
              </Link>{" "} */}
              <button
                className="btn btn-sm btn-danger"
                data-toggle="modal"
                data-target="#modal-default"
                onClick={() => {
                  /* getting id of site to be deleted (defined in AdminSites.jsx component) */
                  document.getElementById("deleteUser").value = item.user_id;
                }}
              >
                <i className="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        ));
        return {
          status: "success",
          optionItems: optionItems,
        };
      } else {
        const getMessage = (
          <tr>
            <td colSpan={9} className="text-center">
              {" "}
              {response.data.message}
            </td>
          </tr>
        );
        return {
          status: "failure",
          optionItems: getMessage,
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to get all doctors list
  Created By: Dinesh Kumar 
*/
export const getParticipantsList = (bodyFormData) => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */
  return axiosInstance
    .post("v1/manage_participants/", bodyFormData)
    .then((response) => {
      let results = response.data.data;
      if (results) {
        return {
          status: "success",
          data: results,
        };
      } else {
        return {
          status: "failure",
          message: "Result not found",
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Common function to update  doctors status
  Created By: Dinesh Kumar 
*/
export const updateParticipantStatus = (pID, participantStatus) => {
  const axiosInstance = AxiosConfiguration();
  const bodyFormData = new FormData();
  let url = "v1/participant_update_status/";

  bodyFormData.append("participant_id", pID);
  bodyFormData.append("participant_status", participantStatus);

  return axiosInstance
    .post(url, bodyFormData)
    .then((response) => {
      return {
        status: response.data.status,
        message: response.data.message,
      };
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/* 
  Purpose:    Used to get doctor details by doctor id
  Created By: Dinesh kumar 
*/
export const getparticipantdetails = (participant_id) => {
  const axiosInstance = AxiosConfiguration();
  let bodyFormData = new FormData();
  bodyFormData.append("participant_id", participant_id);
  return axiosInstance
    .post("v1/participant_details/", bodyFormData)
    .then((response) => {
      let results = response.data.data;
      if (results) {
        return {
          status: "success",
          results: results[0],
        };
      } else {
        return {
          status: "failure",
          message: "Result not found",
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to get all participants list for assing to group for survey
  Created By: Dinesh Kumar 
*/
export const getAllParticipansList = (bodyFormData) => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */
  return axiosInstance
    .post("v1/get_all_participants/", bodyFormData)
    .then((response) => {
      let results = response.data.data;
      if (results) {
        return {
          status: "success",
          data: results,
        };
      } else {
        return {
          status: "failure",
          message: "Result not found",
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose: Used to get all users list based on user type
  Created By: Dinesh Kumar 
*/
export const getAllQualitySupervisors = (bodyFormData) => {
  const axiosInstance =
    AxiosConfiguration(); /* calling axios configuration (Defined in:- Utils/AxiosConfig.js) */
  return axiosInstance
    .post("app/v1/get_users_for_approval/", bodyFormData)
    .then((response) => {
      let results = response.data.data;
      if (results) {
        return {
          status: "success",
          data: results,
        };
      } else {
        return {
          status: "failure",
          message: "Result not found",
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/*
  Purpose:    common function to update  survey status
  Created By: Vinit Kumar 
*/
export const surveyDraftandreportRejection = (bodyFormData) => {
  const axiosInstance = AxiosConfiguration();
  let url = "v1/survey_draft_report_rejection/";
  return axiosInstance
    .post(url, bodyFormData)
    .then((response) => {
      return {
        status: response.data.status,
        message: response.data.message,
      };
    })
    .catch((error) => {
      console.log(error);
      return Constant.API_ERROR;
    });
};

/* 
  Purpose:    Used to get draft relesed survey list for Quality supervisor
  Created By: Dinesh kumar 
*/
export const getSurveyDraftAndReportapprovalList = (bodyFormData) => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("v1/survey_draft_report_approval/", bodyFormData)
    .then((response) => {
      let results = response.data.data;
      if (results) {
        return {
          status: "success",
          data: results,
        };
      } else {
        return {
          status: "failure",
          message: "Result not found",
        };
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};
